import {createSlice } from '@reduxjs/toolkit'

const AddUserSlice = createSlice({
    name: "AddUserSlice",
    initialState: {
        AddedUser: {
            id: '',
            FIO: '',
            Email: '',
            Password: '',
            Role: ''
        },
        EditUser: false
    },
    reducers: {
       ChangeValueAddUser(state, actions){
        switch(actions.payload.Type){
            case('FIO'):{
                state.AddedUser.FIO = actions.payload.Value
                break;
            }
            case('Email'):{
                state.AddedUser.Email = actions.payload.Value
                break;
            }
            case('Password'):{
                state.AddedUser.Password = actions.payload.Value
                break;
            }
            default:{
                break;
            }
        }
       },
       CleanValueAddUser(state){
        state.AddedUser = {
            id: '',
            FIO: '',
            Email: '',
            Password: '',
            Role: ''
        }
        state.EditUser = false
       },
       addEditUser(state, actions){
        state.AddedUser.FIO = actions.payload.FIO
        state.AddedUser.Email = actions.payload.Email
        state.AddedUser.id = actions.payload.idUser
        state.AddedUser.Role = actions.payload.Role
        state.EditUser = true
       }
    }
})

export default AddUserSlice.reducer
export const { addEditUser, ChangeValueAddUser, CleanValueAddUser } = AddUserSlice.actions